import { Module } from "vuex";
import { State } from "@/store/modules/status/state";
import Mutations from "@/store/modules/status/mutations";
import Getters from "@/store/modules/status/getters";
import Actions from "@/store/modules/status/actions";

export class Status implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
